import { expVal } from '@confluence/feature-experiments';

/**
 * Re-evaluates experiments in the browser when their initial evaluation cannot emit an exposure.
 */
export const fireSSRExperimentExposures = () => {
	expVal('move_statsig_bootstrap_after_fmp', 'isEnabled', false);
	expVal('confluence_media_token_preload_agg_query', 'isEnabled', false);
	expVal('confluence_skip_ors_for_jira_smartlinks', 'isEnabled', false);
	// The browser only evaluates this when SSR hands a blocked query to the client, which happens in Test only.
	expVal('confluence_ssr_blocked_query_client_render', 'isEnabled', false);
};
